(function () {
  if (window.__stsCartReady) return;
  window.__stsCartReady = true;

  /* ── Helpers ── */
  function formatMoney(cents) {
    return '\u20b9' + (cents / 100).toFixed(2);
  }

  function updateCartBubble(count) {
    var bubble = document.querySelector('.cart-count-bubble [aria-hidden]');
    if (!bubble) return;
    bubble.textContent = count;
    var wrap = bubble.closest('.cart-count-bubble');
    if (wrap) wrap.style.display = count > 0 ? 'flex' : 'none';
  }

  /* ── Cart Drawer ── */
  function openCartDrawer() {
    fetchAndRenderCart();
    document.getElementById('sts-cart-drawer').classList.add('is-open');
    document.getElementById('sts-cd-overlay').classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var drawer = document.getElementById('sts-cart-drawer');
    var overlay = document.getElementById('sts-cd-overlay');
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function fetchAndRenderCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function renderCart(cart) {
    var itemsEl  = document.getElementById('sts-cd-items');
    var footerEl = document.getElementById('sts-cd-footer');
    var emptyEl  = document.getElementById('sts-cd-empty');
    if (!itemsEl) return;

    updateCartBubble(cart.item_count);

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl)  emptyEl.style.display  = '';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (emptyEl)  emptyEl.style.display  = 'none';
    if (footerEl) footerEl.style.display = '';

    var subtotalEl = document.getElementById('sts-cd-subtotal');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    itemsEl.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image + '" alt="' + item.product_title.replace(/"/g, '') + '" width="72" height="72" loading="lazy">'
        : '<div class="sts-cd__item-img-placeholder"></div>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="sts-cd__item-variant">' + item.variant_title + '</p>'
        : '';
      return (
        '<div class="sts-cd__item" data-key="' + item.key + '">' +
          img +
          '<div class="sts-cd__item-info">' +
            '<p class="sts-cd__item-title">' + item.product_title + '</p>' +
            variant +
            '<div class="sts-cd__item-row">' +
              '<div class="sts-cd__qty">' +
                '<button class="sts-cd__qty-btn" data-action="minus" data-key="' + item.key + '" aria-label="Decrease">&#8722;</button>' +
                '<span class="sts-cd__qty-val">' + item.quantity + '</span>' +
                '<button class="sts-cd__qty-btn" data-action="plus" data-key="' + item.key + '" aria-label="Increase">+</button>' +
              '</div>' +
              '<span class="sts-cd__item-price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button class="sts-cd__remove" data-key="' + item.key + '" aria-label="Remove item">&times;</button>' +
        '</div>'
      );
    }).join('');
  }

  function changeCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  /* ── Cart Page ── */
  function fetchAndRenderCartPage() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCartPage);
  }

  function renderCartPage(cart) {
    var itemsEl   = document.getElementById('sts-cp-items');
    var emptyEl   = document.getElementById('sts-cp-empty');
    var layoutEl  = document.getElementById('sts-cp-layout');
    var subtotalEl = document.getElementById('sts-cp-subtotal');
    if (!itemsEl) return;

    updateCartBubble(cart.item_count);

    if (cart.item_count === 0) {
      if (emptyEl)  emptyEl.style.display  = '';
      if (layoutEl) layoutEl.style.display = 'none';
      return;
    }
    if (emptyEl)  emptyEl.style.display  = 'none';
    if (layoutEl) layoutEl.style.display = '';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    itemsEl.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image + '" alt="' + item.product_title.replace(/"/g, '') + '" width="80" height="80" loading="lazy">'
        : '<div class="sts-cp__item-img-placeholder"></div>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="sts-cp__item-variant">' + item.variant_title + '</p>' : '';
      var unit = '<p class="sts-cp__item-unit">' + formatMoney(item.price) + ' each</p>';
      return (
        '<div class="sts-cp__item" data-key="' + item.key + '">' +
          '<div class="sts-cp__item-product">' +
            img +
            '<div class="sts-cp__item-meta">' +
              '<p class="sts-cp__item-title">' + item.product_title + '</p>' +
              variant + unit +
            '</div>' +
          '</div>' +
          '<div class="sts-cp__item-qty">' +
            '<div class="sts-cp__qty-wrap">' +
              '<button class="sts-cp__qty-btn" data-action="minus" data-key="' + item.key + '" aria-label="Decrease">&#8722;</button>' +
              '<span class="sts-cp__qty-val">' + item.quantity + '</span>' +
              '<button class="sts-cp__qty-btn" data-action="plus"  data-key="' + item.key + '" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="sts-cp__item-total">' +
            '<span class="sts-cp__item-price">' + formatMoney(item.final_line_price) + '</span>' +
            '<button class="sts-cp__remove-btn" data-key="' + item.key + '">Remove</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function changeCartItemPage(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCartPage);
  }

  function saveCartNote() {
    var note = document.getElementById('sts-cp-note');
    if (!note) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value })
    });
  }

  /* ── Mobile Menu ── */
  function openMobileMenu() {
    document.getElementById('sts-mob-drawer').classList.add('is-open');
    document.getElementById('sts-mob-overlay').classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var btn = document.querySelector('[data-menu-open]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function closeMobileMenu() {
    var drawer  = document.getElementById('sts-mob-drawer');
    var overlay = document.getElementById('sts-mob-overlay');
    if (drawer)  drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    var btn = document.querySelector('[data-menu-open]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  /* ── ATC ── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList.contains('sts-atc-form')) return;
    e.preventDefault();
    var btn = form.querySelector('.sts-atc-btn');
    if (!btn) return;
    var orig = btn.innerHTML;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(form))
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added!';
        setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 1500);
        openCartDrawer();
      })
      .catch(function () { btn.innerHTML = orig; btn.disabled = false; });
  });

  /* ── Event delegation ── */
  document.addEventListener('click', function (e) {

    /* Cart drawer open */
    if (e.target.closest('[data-cart-drawer-open]')) {
      openCartDrawer();
      return;
    }

    /* Cart drawer close */
    if (e.target.closest('[data-cart-drawer-close]')) {
      closeCartDrawer();
      return;
    }

    /* Cart qty +/− */
    var qtyBtn = e.target.closest('.sts-cd__qty-btn');
    if (qtyBtn) {
      var key = qtyBtn.dataset.key;
      var itemEl = qtyBtn.closest('.sts-cd__item');
      var current = parseInt(itemEl.querySelector('.sts-cd__qty-val').textContent, 10);
      var next = qtyBtn.dataset.action === 'plus' ? current + 1 : Math.max(0, current - 1);
      changeCartItem(key, next);
      return;
    }

    /* Cart item remove */
    var removeBtn = e.target.closest('.sts-cd__remove');
    if (removeBtn) {
      changeCartItem(removeBtn.dataset.key, 0);
      return;
    }

    /* Mobile menu open */
    if (e.target.closest('[data-menu-open]')) {
      openMobileMenu();
      return;
    }

    /* Mobile menu close */
    if (e.target.closest('[data-menu-close]')) {
      closeMobileMenu();
      return;
    }

    /* Variant pill switcher */
    var pill = e.target.closest('.sts-card__vpill');
    if (pill) {
      var card = pill.closest('[data-product-id]');
      if (!card) return;
      card.querySelectorAll('.sts-card__vpill').forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      var input = card.querySelector('[data-variant-input]');
      if (input) input.value = pill.dataset.variantId;
      var priceEl   = card.querySelector('[data-price]');
      var compareEl = card.querySelector('[data-compare]');
      if (priceEl && pill.dataset.price) priceEl.textContent = formatMoney(parseInt(pill.dataset.price, 10));
      if (compareEl) {
        var cmp = parseInt(pill.dataset.compare, 10);
        if (cmp > 0) { compareEl.textContent = formatMoney(cmp); compareEl.style.display = ''; }
        else { compareEl.style.display = 'none'; }
      }
      return;
    }

    /* Qty stepper */
    var stepBtn = e.target.closest('[data-qty-minus],[data-qty-plus]');
    if (stepBtn) {
      var stepCard = stepBtn.closest('[data-product-id]');
      if (!stepCard) return;
      var stepInput = stepCard.querySelector('[data-qty-input]');
      if (!stepInput) return;
      var val = parseInt(stepInput.value, 10) || 1;
      if (stepBtn.hasAttribute('data-qty-minus') && val > 1) stepInput.value = val - 1;
      if (stepBtn.hasAttribute('data-qty-plus')) stepInput.value = val + 1;
      return;
    }

    /* Category carousel arrows */
    var carouselBtn = e.target.closest('[data-catc-prev],[data-catc-next]');
    if (carouselBtn) {
      var track = document.getElementById('sts-catc-track');
      if (!track) return;
      track.scrollBy({ left: carouselBtn.hasAttribute('data-catc-prev') ? -220 : 220, behavior: 'smooth' });
      return;
    }

    /* FAQ accordion */
    var faqBtn = e.target.closest('[data-cfaq-toggle]');
    if (faqBtn) {
      var isOpen = faqBtn.classList.toggle('is-open');
      faqBtn.setAttribute('aria-expanded', String(isOpen));
      var answer = faqBtn.nextElementSibling;
      if (answer) answer.classList.toggle('is-open');
      return;
    }

    /* Cart page qty +/- */
    var cpQtyBtn = e.target.closest('.sts-cp__qty-btn');
    if (cpQtyBtn) {
      var cpKey     = cpQtyBtn.dataset.key;
      var cpItemEl  = cpQtyBtn.closest('.sts-cp__item');
      var cpCurrent = parseInt(cpItemEl.querySelector('.sts-cp__qty-val').textContent, 10);
      var cpNext    = cpQtyBtn.dataset.action === 'plus' ? cpCurrent + 1 : Math.max(0, cpCurrent - 1);
      changeCartItemPage(cpKey, cpNext);
      return;
    }

    /* Cart page remove */
    var cpRemoveBtn = e.target.closest('.sts-cp__remove-btn');
    if (cpRemoveBtn) {
      changeCartItemPage(cpRemoveBtn.dataset.key, 0);
      return;
    }

  });

  /* Close drawers on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeCartDrawer();
    closeMobileMenu();
  });

  /* Dynamic header height — keeps body padding-top accurate at every breakpoint */
  function measureHeader() {
    var h = document.getElementById('sts-header');
    if (h) document.documentElement.style.setProperty('--sts-header-height', h.offsetHeight + 'px');
  }

  /* Init cart bubble — show if Liquid rendered a non-zero count on page load */
  function initCartBubble() {
    var bubble = document.querySelector('.cart-count-bubble [aria-hidden]');
    if (!bubble) return;
    var count = parseInt(bubble.textContent, 10) || 0;
    var wrap = bubble.closest('.cart-count-bubble');
    if (wrap) wrap.style.display = count > 0 ? 'flex' : 'none';
  }

  document.addEventListener('DOMContentLoaded', measureHeader);
  document.addEventListener('DOMContentLoaded', initCartBubble);
  document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('sts-cart-page')) fetchAndRenderCartPage();
  });
  window.addEventListener('resize', measureHeader);

  /* Save cart note on blur */
  document.addEventListener('change', function (e) {
    if (e.target.id === 'sts-cp-note') saveCartNote();
  });

})();
